import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function IntellectualPropertyLaw() {

  useEffect(() => {
    document.title = "Intellectial Property Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="/intellectual-property-law.webp" 
              alt="Intellectual Property Law" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
              At Legal Trails, we offer robust support in various litigation matters, ensuring our clients receive thorough and strategic assistance. Our services include the preparation of cease and desist notices, crafted to clearly communicate infringements and demand compliance. We also provide detailed responses to examination reports, meticulously addressing each point to advocate for our clients' interests. Additionally, we handle notices of opposition, preparing strong arguments to defend our clients against challenges. Our experienced team is adept at drafting counter statements, ensuring that our clients' positions are articulated with precision and clarity. Finally, we manage all aspects of suits and legal filings, ensuring adherence to procedural requirements and deadlines. With a focus on achieving the best possible outcomes, Legal Trails is committed to delivering effective litigation support tailored to our clients' needs.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default IntellectualPropertyLaw;
